/* eslint-disable no-unused-vars */
import TablePagination from "@mui/material/TablePagination";
import * as React from "react";
import swal from "sweetalert";
import {
  CreateEstablishmentItemCategory,
  GetAllEstablishmentItemCategory,
  UpdateEstablishmentItemCategory,
} from "../../../axios";
import {
  AddIcon,
  BreadCrumbs,
  FormTextInput,
  IconButton,
  Modal,
  NodataFound,
  SearchMappingTable,
} from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import {
  CreateEstabishmentToItemCategoryMappingForm,
  DeleteBudgetScopeToItemCategoryMappingForm,
} from "../../../forms";
import "../../../styles/tablepagination.css";
import { default as Strings, default as strings } from "../../../translations";
import { isAuthorizedFunc } from "../../../utils";
import {
  CREATE_ESTABLISHMENT_ITEM_CATEGORY,
  UPDATE_ESTABLISHMENT_ITEM_CATEGORY,
} from "../../../utils/constants";

export default function SearchEstabishmentToItemCategoryMappingPage() {
  const searchTitle =
      Strings["EstablishmentMasterConfiguration.DashboardTitle"],
    activeStatus =
      Strings["EstablishmentMasterConfiguration.TableHead.activeStatus"],
    action = Strings["EstablishmentMasterConfiguration.TableHead.action"];

  const [isOpen, setIsOpen] = React.useState(false);
  const [clickedBtn, setClickedBtn] = React.useState("");
  const [currentType, setCurrentType] = React.useState({});
  const [errorMessage, setMessage] = React.useState(null);
  const [currentUserMapping, setCurrentUserMapping] = React.useState({});
  const [rows, setRows] = React.useState([]);
  const [uid, setUid] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalData, setTotalData] = React.useState(null);
  const [isAdd, setAdd] = React.useState(true);
  const [isUpdate, setIsUpdate] = React.useState(true);
  const [searchValue, setSearchValue] = React.useState({
    value: "",
    error: false,
    success: false,
  });
  React.useEffect(() => {
    if (isAuthorizedFunc(CREATE_ESTABLISHMENT_ITEM_CATEGORY)) {
      setAdd(true);
    } else {
      setAdd(false);
    }
  }, []);

  React.useEffect(() => {
    if (isAuthorizedFunc(UPDATE_ESTABLISHMENT_ITEM_CATEGORY)) {
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  }, []);

  const paths = [
    {
      name: strings["MasterConfigurationText"],
      path: "master-configuration",
    },
    {
      name: strings["EstablishmentToItemCategoryMappingText"],
      path: "master-configuration/searchestablishmenttoitemcategorymapping",
    },
  ];
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  const openAddModal = () => {
    setIsOpen(true);
  };
  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleSelectBtn = (btn) => {
    setClickedBtn(btn);
  };
  const getAllEstablishmentItemCategory = () => {
    setLoading(true);
    GetAllEstablishmentItemCategory(rowsPerPage, page, searchValue.value)
      .then((res) => {
        setLoading(false);
        setRows(res.data.data);
        setTotalData(res.data.total);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getAllEstablishmentItemCategory();
  }, [rowsPerPage, page]);
  const createEstablishMap = (formData) => {
    setLoading(true);
    CreateEstablishmentItemCategory(formData)
      .then((res) => {
        if (res.status === 200) {
          getAllEstablishmentItemCategory();
          setLoading(false);
          swal({
            title: "Success!",
            text: res.data.message,
            icon: "success",
          });
          handleModalClose();
        }
      })
      .catch((e) => {
        setLoading(false);
        setMessage(e.response.data.message);
      });
  };
  const updateEstablishItemMap = (formData) => {
    setLoading(true);
    UpdateEstablishmentItemCategory(formData)
      .then((res) => {
        getAllEstablishmentItemCategory();
        if (res.status === 200) {
          setLoading(false);
          swal({
            title: "Success!",
            text: res.data.message,
            icon: "success",
          });
        }
        handleModalClose();
      })
      .catch((e) => {
        setLoading(false);
        setMessage(e.response.data.message);
      });
  };

  const selectModal = () => {
    if (clickedBtn === "add") {
      return (
        <CreateEstabishmentToItemCategoryMappingForm
          setMessage={setMessage}
          errorMessage={errorMessage}
          handleResultData={createEstablishMap}
          actionType="add"
          handleModalClose={handleModalClose}
        />
      );
    } else if (clickedBtn === "edit") {
      return (
        <CreateEstabishmentToItemCategoryMappingForm
          errorMessage={errorMessage}
          setMessage={setMessage}
          handleResultData={updateEstablishItemMap}
          handleModalClose={handleModalClose}
          initialValue={currentType}
          actionType="edit"
          uid={uid}
        />
      );
    } else {
      return (
        <DeleteBudgetScopeToItemCategoryMappingForm
          deleteChangeFormData={(val) => {}}
          initialValue={currentUserMapping}
          actionType={clickedBtn}
        />
      );
    }
  };

  const converter = (rows) => {
    let result = "";
    rows.forEach((data) => {
      if (result.length === 0) {
        result = result + data.name;
      } else {
        result = result + "," + data.name;
      }
    });
    return result;
  };

  const getData = (rows) => {
    const result = rows.map((data) => {
      return {
        ...data,
        itemcategories: converter(data.itemcategories),
      };
    });
    return result;
  };

  const searchTableData = getData(rows);

  const mapableData = [
    {
      dataKey: "name",
      title: "Establishment",
    },
    {
      dataKey: "itemcategories",
      title: "Item Category",
    },
    {
      dataKey: "is_active",
      title: activeStatus,
      isStatus: true,
    },
    {
      dataKey: "id",
      title: action,
      isAction: true,
    },
  ];

  const handleChangeEdit = (id) => {
    openAddModal();
    const result = rows.find((row) => {
      return row.id === id;
    });
    setCurrentType(result);
    handleSelectBtn("edit");
    setUid(result.id);
  };
  const handleSearch = (searchData) => {
    const data = searchData.value;
    setSearchValue(searchData);
    if (searchData.value === "") {
      setLoading(true);
      GetAllEstablishmentItemCategory(rowsPerPage, page, searchData.value)
        .then((res) => {
          setLoading(false);
          setRows(res.data.data);
          setTotalData(res.data.total);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
    // const filterData = tempData.filter((d) => {
    //     return d[searchProp].toLowerCase().includes(data);
    // })
    // if (data === "") {
    //   setAllData(tempData);
    // } else {
    //   setAllData(filterBuilderData(allData, query));
    // }
  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    getAllEstablishmentItemCategory();
  };
  return (
    <>
      <div className="container">
        {loading ? <LoaderComponent /> : null}
        <Modal onHandleClose={handleModalClose} isOpen={isOpen}>
          {selectModal()}
        </Modal>
        <div className="row mt-4">
          <div className="col">
            <h3> {searchTitle} </h3>
            <BreadCrumbs pathList={paths} />
          </div>
          {isAdd && (
            <div className="col-auto">
              <span className="addButton">
                <IconButton
                  onClick={() => {
                    openAddModal();
                    handleSelectBtn("add");
                  }}
                >
                  <AddIcon />
                </IconButton>
              </span>
            </div>
          )}
          <div className="row">
            <div className="col-12">
              <div className="UserbudgetTable">
                <form onSubmit={handleSearchSubmit}>
                  <FormTextInput
                    type="text"
                    className="searchBarUser mb-3"
                    placeholder={`Search `}
                    Value={searchValue.value}
                    onChangeText={handleSearch}
                    inputStyle={{ border: "none" }}
                    editable
                  />
                </form>
                {rows.length !== 0 ? (
                  <>
                    <SearchMappingTable
                      isUpdate={isUpdate}
                      placeholder="Establishment"
                      data={searchTableData}
                      mapableData={mapableData}
                      searchProp={["name"]}
                      handleChangeEdit={handleChangeEdit}
                    />
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 15]}
                      component="div"
                      count={totalData}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </>
                ) : (
                  <>
                    {loading ? (
                      <LoaderComponent />
                    ) : (
                      <NodataFound
                        onClick={() => {
                          openAddModal();
                          handleSelectBtn("add");
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
